import { Link } from "react-router-dom";

/** Ranked horizontal bars, single series.
 *
 *  One series means no legend — the section title names it — and one hue rather
 *  than a categorical palette. Every bar is directly labelled, so the values are
 *  readable without relying on the mark. Data-end is rounded, the baseline end is
 *  square, and rows carry a surface gap between fills. A bar with `href` links
 *  to its detail page.
 */
export interface Bar {
  key: string;
  label: string;
  value: number;
  valueLabel: string;
  meta?: string;
  href?: string;
}

export function BarList({ bars, max }: { bars: Bar[]; max?: number }) {
  if (!bars.length) return <p className="empty">Nothing to show.</p>;
  const ceiling = max ?? Math.max(...bars.map((b) => b.value), 1);
  return (
    <ol className="bars">
      {bars.map((b) => (
        <li key={b.key} className="bar-row" title={`${b.label} — ${b.valueLabel}`}>
          <span className="bar-label">{b.href ? <Link to={b.href}>{b.label}</Link> : b.label}</span>
          <span className="bar-track">
            <span className="bar-fill" style={{ inlineSize: `${Math.max((b.value / ceiling) * 100, 0.6)}%` }} />
          </span>
          <span className="bar-value">
            {b.valueLabel}
            {b.meta && <span className="bar-meta"> {b.meta}</span>}
          </span>
        </li>
      ))}
    </ol>
  );
}
